import { Component, PropSync, Vue } from "vue-property-decorator";

@Component<LightBoxAdd>({
  components: {}
})
export default class LightBoxAdd extends Vue {
  @PropSync("show", { type: Boolean })
  syncedShow!: boolean;

  private searchInput = "";
  private searchList: string[] = [];

  private search() {
    if (this.$data.searchInput !== "") {
      // TODO: search
    }
  }

  private takeIn(index: number) {
    this.$emit("takeIn", this.$data.searchList[index]);
  }

  private closeLightBox() {
    this.$emit("closeLightBox");
  }
}
